export const settingsApiErrorCode: Record<string, string> = {
  INTERNAL_SERVER_ERROR: 'internalServerError',
  BAD_REQUEST: 'badRequest',
  MAXIMUM_UPLOAD_SIZE_EXCEEDED: 'maximumUploadSize',
  FORMAT_NOT_SUPPORTED: 'formatNotSupported',
};
